// AUTO-GENERATED by tools/measure-ink-offsets.mjs — DO NOT hand-edit.
// Run `npm run fonts:ink` to regenerate (do this whenever fonts are added/changed).
//
// Per-font vertical ink-center offset from the SVG `dominant-baseline:central`
// line, as a FRACTION OF EM. + = ink sits ABOVE central (top word rides out,
// bottom rides in); - = below. render-engine.js shifts each arc's path radius by
// `ink * fontSize` (sign-aware) to re-center the letters in the ring band.
// Well-behaved fonts measure ~0 and are dead-zoned to exactly 0 (they never move).
export default {
  "abril": -0.032,
  "alfaslab": 0.038,
  "annie": 0.025,
  "anton": 0,
  "archivo": 0.011,
  "archivoblack": -0.016,
  "archivonarrow": -0.017,
  "baloo": 0.029,
  "bangers": 0.022,
  "barlow": -0.048,
  "barlowcond": -0.048,
  "bbhbartle": 0,
  "bebas": 0.052,
  "bigshoulders": 0.017,
  "blackops": 0.037,
  "bodoni": 0.013,
  "bowlby": 0.027,
  "bowlbyone": 0.035,
  "bungee": 0,
  "bungeeshade": -0.057,
  "cardo": 0.034,
  "castorotitling": 0.096,
  "caveat": -0.019,
  "chakra": 0.011,
  "changaone": -0.038,
  "chango": -0.038,
  "chivo": 0,
  "cinzel": 0.049,
  "cinzeldeco": -0.025,
  "college": 0.013,
  "collegebold": 0.013,
  "collegecond": 0.013,
  "collegesemi": 0.013,
  "courgette": 0.029,
  "courierprime": 0.071,
  "dancing": 0,
  "danfo": -0.042,
  "dmsans": 0.011,
  "dmserif": -0.019,
  "dosis": -0.027,
  "ebgaramond": -0.03,
  "epilogue": 0.093,
  "figtree": 0,
  "firacond": 0.012,
  "fjallaone": 0.039,
  "fraunces": -0.01,
  "fugaz": 0.049,
  "germania": 0.019,
  "girlnextdoor": 0.152,
  "gloria": 0.024,
  "goldman": 0,
  "graduate": 0,
  "greatvibes": 0.085,
  "hanken": 0,
  "inter": 0,
  "jakarta": -0.033,
  "josefin": 0.116,
  "josefinslab": 0.1,
  "jost": 0,
  "kanit": -0.028,
  "kaushan": -0.025,
  "khand": 0.059,
  "labelle": 0.238,
  "leaguegothic": 0,
  "lexend": -0.022,
  "librebaskerville": 0.036,
  "lilita": 0,
  "lobster": -0.01,
  "lora": -0.015,
  "luckiestguy": -0.01,
  "lugrasimo": 0.088,
  "manrope": -0.021,
  "marcellus": 0,
  "michroma": -0.068,
  "moderustic": -0.024,
  "monoton": 0.03,
  "montserrat2": 0,
  "mulish": -0.023,
  "newamsterdam": 0,
  "newrocker": 0,
  "nixie": 0,
  "nunito": 0.026,
  "ooohbaby": 0.031,
  "orbitron": -0.02,
  "oswald": -0.046,
  "outfit": -0.016,
  "overpass": 0.103,
  "pacifico": -0.039,
  "passionone": 0.027,
  "pathwaygothic": -0.027,
  "paytone": -0.07,
  "permanentmarker": -0.039,
  "playfair": -0.062,
  "playwriteau": 0.039,
  "pompiere": 0.063,
  "poppins": 0,
  "prata": 0.085,
  "ptsansnarrow": -0.019,
  "questrial": 0.029,
  "quicksand": -0.021,
  "racingsans": -0.027,
  "rajdhani": 0.033,
  "redhat": 0,
  "reenie": 0.03,
  "righteous": -0.013,
  "roboto": 0,
  "robotocond": 0,
  "rowdies": -0.02,
  "rozha": 0,
  "rubik": 0,
  "rubikmono": 0.039,
  "rye": 0.014,
  "sairacond": 0,
  "sciencegothic": 0,
  "shrikhand": 0.037,
  "sigmar": -0.015,
  "silkscreen": -0.075,
  "sora": 0.028,
  "spacegrotesk": 0,
  "specialelite": 0.141,
  "spectral": 0.033,
  "squadaone": 0,
  "staatliches": 0.025,
  "teko": 0.081,
  "tektur": 0,
  "titanone": -0.039,
  "tuffy": -0.044,
  "ultra": 0,
  "urbanist": 0,
  "worksans": -0.011,
  "yanone": 0.083,
  "yellowtail": 0.011,
  "yeseva": 0.013,
  "ysabeausc": -0.051,
  "zendots": 0.03,
  "zillaslab": -0.018,
};
